// Per-client service map + partnership narrative provided by the user.
// - services: [emoji, label] pairs rendered as "How we cover [Client]" pills.
// - partnership: unique 1-2 sentence narrative for the "Our partnership" panel.
// When a client is not listed here, ClientDetail hides both sections until
// the user provides copy.

export const CLIENT_SERVICES = {
  aco: {
    partnership:
      "ACO's channel drainage sits under some of the UK's most demanding surfaces, our job is to make sure highways engineers see it every time they specify. Our full campaign, editorial and social programme keeps the brand front-of-mind across the sector.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
      ["🌐", "Website Promotion"],
    ],
  },
  blakedale: {
    partnership:
      "Blakedale runs one of the most respected TM vehicle fleets in the country. We turn every new IPV, TMA and marker-vehicle launch into features, films and campaigns the sector actually reads.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
      ["🌐", "Website Promotion"],
    ],
  },
  "bt-hs": {
    partnership:
      "BT-HS delivers the kind of TM and civils work that everyone talks about after site. We help them turn that reputation into visible industry authority, every project, community initiative and award.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
      ["🌐", "Website Promotion"],
    ],
  },
  cappagh: {
    partnership:
      "Cappagh is one of London's quietly formidable civils outfits. Our films, photography and case-study production keep their delivery record front-of-mind with framework decision-makers.",
    services: [
      ["🎥", "Video Production"],
      ["🎬", "Video Editing"],
      ["📸", "Photography"],
      ["📊", "Presentation Production"],
      ["🎥", "Case Study Videos"],
    ],
  },
  "cd-fencing": {
    partnership:
      "CD Fencing is the go-to name for sites that can't afford to look temporary. We built and maintain the website, and keep a steady stream of features and newsletter coverage running, turning serious perimeter work into a serious sector reputation.",
    services: [
      ["🌐", "Website Development"],
      ["🛠️", "Website Maintenance"],
      ["📰", "Featured Articles"],
      ["📧", "Newsletter Marketing"],
    ],
  },
  "chellan-highway-safety-services": {
    partnership:
      "Chellan's road marking, studs and anti-skid work only get noticed when they're missing. Our job is to make the sector notice, for all the right reasons, through campaigns, features and social work that celebrates the discipline.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
      ["🌐", "Website Promotion"],
    ],
  },
  "city-tm": {
    partnership:
      "City TM punches above its weight across the South East, event work, high-speed schemes and local-authority contracts. We built their website and run the full editorial, campaign and social programme around it, everything short of video, and the growth speaks for itself.",
    services: [
      ["🌐", "Website Development"],
      ["🛠️", "Website Maintenance"],
      ["⚙️", "Technical Support"],
      ["🖥️", "Website Hosting"],
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["✍️", "Copywriting"],
      ["📸", "Photography"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
      ["🚀", "LIFT Campaigns"],
      ["🎪", "Event Marketing"],
      ["📢", "Digital Advertising"],
    ],
  },
  coeval: {
    partnership:
      "Coeval builds intelligent warning tech that quietly saves lives. We package that story into campaigns, features and digital tools that put their engineering in front of the specifiers who choose it.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
      ["🚀", "LIFT Campaigns"],
      ["🌐", "Website Development"],
      ["🛠️", "Website Maintenance"],
      ["⚙️", "Technical Support"],
      ["🎪", "Event Marketing"],
    ],
  },
  "consilium-technical-services": {
    partnership:
      "Consilium's engineering brain trust is the kind of quiet asset the sector needs to hear more about. We built and host the website and technical platform that finally reflects the depth of what they actually do.",
    services: [
      ["🌐", "Website Development"],
      ["🖥️", "Website Hosting"],
      ["🛠️", "Website Maintenance"],
      ["⚙️", "Technical Support"],
    ],
  },
  "core-highways": {
    partnership:
      "Core Highways is one of the fastest-growing names in national TM and barrier delivery. We're building the training platform that keeps their people, and their reputation, ahead of the industry curve.",
    services: [
      ["🎓", "Training Hub Development"],
      ["🌐", "Digital Learning Platform"],
    ],
  },
  "crown-highways": {
    partnership:
      "Crown Highways runs some of the most technically demanding highways electrical schemes in the Midlands. Our full-stack partnership makes sure every project, award and community moment gets the audience it deserves, with campaigns, films, features and website work all under one roof.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["✍️", "Copywriting"],
      ["🎥", "Video Production"],
      ["📸", "Photography"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
      ["🌐", "Website Management"],
      ["🎪", "Event Marketing"],
      ["🤝", "Sponsorship Management"],
    ],
  },
  "crown-plus": {
    partnership:
      "Crown Plus is the delivery layer under a lot of headline schemes. Our campaign and website work turns that quiet capacity into a brand contractors actively look for.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["🎥", "Video Production"],
      ["🌐", "Website Promotion"],
      ["⚙️", "Technical Support"],
      ["🛠️", "Website Maintenance"],
    ],
  },
  "deltabloc-uk": {
    partnership:
      "DELTABLOC's global engineering pedigree deserves UK-market visibility to match. Our editorial, video and social work puts their kit into every barrier conversation happening on the network.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  hrs: {
    partnership:
      "HRS is building the automated future of work-zone safety. Our drone films and video production make sure operators, clients and regulators can actually see what that future looks like, on the road, at speed.",
    services: [
      ["🚁", "Drone Filming"],
      ["🎥", "Video Production"],
    ],
  },
  htm: {
    partnership:
      "HTM has one of the deepest field cultures in traffic management. Our campaigns, event coverage and long-term editorial relationship keep that credibility loud, current and impossible to miss.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📸", "Photography"],
      ["📧", "Newsletter Sponsorship"],
      ["🖥️", "Website Hosting"],
      ["🛠️", "Website Maintenance"],
      ["⚙️", "Technical Support"],
      ["🎪", "Event Coverage"],
    ],
  },
  "highway-care": {
    partnership:
      "Highway Care doesn't stand still on safety, and neither do we. From print and website work to national campaigns and features, we're the marketing engine behind one of the sector's most restless innovators.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
      ["🌐", "Website Promotion"],
      ["⚙️", "Technical Support"],
      ["🛠️", "Website Maintenance"],
      ["🖨️", "Print Design"],
    ],
  },
  "hill-and-smith-infrastructure": {
    partnership:
      "Hill & Smith's kit holds vehicles back on the UK's most critical roads. Our editorial and video work puts the engineering, and the people behind it, in front of the specifiers who choose it.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  hireway: {
    partnership:
      "Hireway is fleet hire built specifically for the highways operating environment. We built the website and keep the news flowing, because when contractors need the right vehicle yesterday, they need to find Hireway first.",
    services: [
      ["🌐", "Website Development"],
      ["🛠️", "Website Maintenance"],
      ["⚙️", "Technical Support"],
      ["🖥️", "Website Hosting"],
      ["📰", "Featured Articles"],
      ["📧", "Newsletter Marketing"],
    ],
  },
  "institute-of-asphalt-technology": {
    partnership:
      "The IAT is where UK asphalt engineers become authoritative. Our website, editorial and campaign work amplifies that authority to the audience that matters most, the industry itself.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["🌐", "Website Development"],
    ],
  },
  instarmac: {
    partnership:
      "Instarmac's UltraCrete keeps the UK network moving. Our ongoing campaigns, features and video work keep the brand as visible as the repairs it enables.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  "kiely-bros": {
    partnership:
      "Kiely Bros has been shaping UK roads for decades, independent, family-run, seriously capable. Our films, podcasts, photography and editorial celebrate the craft, the projects and the people behind them.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["🎙️", "Podcast Production"],
      ["🎬", "Video Editing"],
      ["📸", "Photography"],
    ],
  },
  "kier-transportation-services": {
    partnership:
      "Kier delivers infrastructure at a scale most only read about. Our drone survey work, progress films and technical reporting give their teams the visual record their projects deserve.",
    services: [
      ["🚁", "Drone Surveys"],
      ["🚁", "Drone Filming"],
      ["📊", "Survey Reporting"],
      ["🎥", "Video Production"],
      ["🎬", "Video Editing"],
      ["📈", "Progress Monitoring"],
    ],
  },
  "king-highway-products": {
    partnership:
      "King reinvented pothole patching as a craft. Our campaigns, features and video work take that craft to a global audience, one asphalt story at a time.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  "mac-surfacing": {
    partnership:
      "MAC Surfacing puts down consistent quality across the Midlands without fuss. Our job is to add the fanfare, through features, videos and campaigns the sector actually reads.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  "m-group-telecom": {
    partnership:
      "M Group Telecom keeps the UK connected. Our aerial survey and reporting work gives their teams the site intelligence they need to keep delivering at national scale.",
    services: [
      ["🚁", "Aerial Surveys"],
      ["📊", "Survey Reporting"],
    ],
  },
  "messagemaker-displays-stocksigns-ltd": {
    partnership:
      "Messagemaker's VMS and LED displays are the industry's most visible communications kit. Our campaigns, features and newsletter placements make sure the engineering behind them is just as visible in the specification room.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
    ],
  },
  meon: {
    partnership:
      "Meon owns a huge slice of UK line-marking and anti-skid work. Our features, campaigns and social media output keep the technical detail behind that reputation in constant view.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  "metelec-services": {
    partnership:
      "Metelec keeps infrastructure powered without drama. Our LIFT campaigns, website work and technical support put that reliability in front of the framework buyers who need it.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["📱", "Social Media Management"],
      ["🚀", "LIFT Campaigns"],
      ["🌐", "Website Development"],
      ["⚙️", "Technical Support"],
      ["🛠️", "Website Maintenance"],
    ],
  },
  "miles-macadam": {
    partnership:
      "Miles Macadam brings serious technical rigour to specialist surfacing. Our editorial, video and campaign work makes sure Hardipave and its stablemates show up when the industry looks for solutions.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  multevo: {
    partnership:
      "Multevo has quietly built one of the most efficient road-maintenance operations in the country. Our campaigns, features and videos make sure councils and contractors know exactly why.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  "nissen-uk": {
    partnership:
      "Nissen's lighting, lamps and safety kit turn up on every serious UK site. Our campaigns and features make sure the specifiers know the brand behind the product.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  "ramudden-global-uk-chevron-tm": {
    partnership:
      "Ramudden Global is one of the biggest names in traffic management anywhere on the planet. Our full-stack partnership, from event coverage to national campaigns, makes sure their UK arm punches at the same weight as their global reputation.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["🎬", "Video Editing"],
      ["📸", "Photography"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
      ["🎪", "Event Coverage"],
      ["🎪", "Event Marketing"],
    ],
  },
  "randc-williams": {
    partnership:
      "R&C Williams is the Midlands firm the industry quietly relies on for bridge repair. Our event coverage and photography record the human stories behind the structural CVs.",
    services: [
      ["🎪", "Event Coverage"],
      ["📸", "Photography"],
    ],
  },
  "re-flow": {
    partnership:
      "Re-flow is the field-management platform highways and infrastructure businesses actually use. Our campaigns, features and newsletter sponsorships put their software in front of the operators most likely to switch.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["📧", "Newsletter Sponsorship"],
      ["📱", "Social Media Management"],
      ["🌐", "Website Promotion"],
    ],
  },
  "roadway-tm": {
    partnership:
      "Roadway TM's field culture is why clients call them back. Our website, LIFT campaigns and technical platform work make sure new clients can find that culture in the first place.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["🌐", "Website Development"],
      ["🖥️", "Website Hosting"],
      ["🛠️", "Website Maintenance"],
      ["⚙️", "Technical Support"],
      ["🚀", "LIFT Campaigns"],
    ],
  },
  shimpac: {
    partnership:
      "SHIMPAC's impact protection kit is honest engineering that catches what it's designed to catch. Our LIFT campaigns and features carry that no-nonsense story to a national audience.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🚀", "LIFT Campaigns"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
    ],
  },
  "solar-gates": {
    partnership:
      "Solar Gates is solving one of the sector's ugliest problems, work-zone incursions, with practical solar-powered engineering. Our campaigns, features and video work make sure every operator sees the innovation.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  swarco: {
    partnership:
      "SWARCO covers a huge slice of UK road marking, signals and ITS. Our video editing sharpens their story for the audiences most likely to specify next.",
    services: [["🎬", "Video Editing"]],
  },
  "swarco-smart-charging": {
    partnership:
      "SWARCO Smart Charging is building the EV infrastructure operators actually rely on. Our video production and editing capture the technical polish behind every install.",
    services: [
      ["🎥", "Video Production"],
      ["🎬", "Video Editing"],
    ],
  },
  "tailored-highway-support-ths": {
    partnership:
      "THS runs training, consultancy and TM support with a genuine roadside pedigree. Our campaigns and features put that credibility in front of the people who need it, clients, learners and industry peers alike.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  tarmac: {
    partnership:
      "Tarmac is under and around most of the UK network. Our films, photography and case-study production capture the scale of that delivery, and the people making it happen, for the audiences that drive their next contract.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["🎬", "Video Editing"],
      ["📸", "Photography"],
      ["🎥", "Case Study Videos"],
    ],
  },
  "thomson-protective-coatings": {
    partnership:
      "Thomson quietly protects UK infrastructure from the weather that would otherwise eat it. Our campaigns and features put that protective story in front of the asset owners and engineers who buy it.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
    ],
  },
  tmca: {
    partnership:
      "The TMCA is the industry's collective voice on TM standards, safety and policy. Our LIFT campaigns and technical platform keep that voice loud, live and easy to find.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["🚀", "LIFT Campaigns"],
      ["🖥️", "Website Hosting"],
      ["🛠️", "Website Maintenance"],
      ["⚙️", "Technical Support"],
    ],
  },
  "traffic-group-signals": {
    partnership:
      "Traffic Group Signals is the biggest hirer of portable signals in the UK, and one of the most innovative. Our campaigns, features and video work make sure the market keeps up with the technology.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  "traffic-labour-supplies-tls": {
    partnership:
      "TLS is the labour engine behind a huge slice of UK TM and civils operations. Our LIFT campaigns, digital advertising and features keep their people-pipeline story visible to the operators that need it.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📸", "Photography"],
      ["📢", "Digital Advertising"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
      ["🚀", "LIFT Campaigns"],
    ],
  },
  "up-to-speed-training": {
    partnership:
      "Up To Speed turns qualifications into competence. Our training content, LIFT campaigns and website advertising put their courses in front of the operatives, and employers, most ready to book.",
    services: [
      ["🎓", "Training Content"],
      ["🚀", "LIFT Campaigns"],
      ["📢", "Website Advertising"],
      ["🌐", "Website Promotion"],
    ],
  },
  volkerhighways: {
    partnership:
      "VolkerHighways delivers term maintenance for local authorities up and down the country. Our campaigns, features and video work capture the everyday craft behind every contract.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  wdm: {
    partnership:
      "WDM's technology measures the road surface everyone else has to fix. Our newsletter marketing and sponsorship keep that engineering story in front of the asset managers who buy it.",
    services: [
      ["📧", "Newsletter Marketing"],
      ["📧", "Newsletter Sponsorship"],
    ],
  },
  wj: {
    partnership:
      "WJ is one of the most technically ambitious road-marking groups in the country. Our campaigns, features, photography and newsletter work amplify a project sheet most competitors would envy.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["🎥", "Video Production"],
      ["📸", "Photography"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
    ],
  },
  "national-highways": {
    partnership:
      "National Highways runs England's strategic road network. Our features and newsletter coverage keep every major programme, decision and update in front of the industry that has to deliver it.",
    services: [
      ["📰", "Featured Articles"],
      ["📧", "Newsletter Marketing"],
    ],
  },
  "milestone-infrastructure": {
    partnership:
      "Milestone Infrastructure delivers term maintenance at national scale. Our features and newsletter marketing keep every local-authority partnership visible to the wider industry.",
    services: [
      ["📰", "Featured Articles"],
      ["📧", "Newsletter Marketing"],
    ],
  },
  pogo: {
    partnership:
      "PoGo is a rare EV brand that actually shows up on the roadside where drivers need it. Our features, newsletter marketing and video work make sure the roll-out is impossible to miss.",
    services: [
      ["📰", "Featured Articles"],
      ["📧", "Newsletter Marketing"],
      ["🎥", "Video Production"],
    ],
  },
  "transport-for-london": {
    partnership:
      "TfL is one of the most-watched procurement pipelines in the country. Our features, newsletter marketing and video work make sure the industry knows every headline scheme in real time.",
    services: [
      ["📰", "Featured Articles"],
      ["📧", "Newsletter Marketing"],
      ["🎥", "Video Production"],
    ],
  },
  "triangle-software": {
    partnership:
      "Triangle Software is built by people who've actually run TM and field-service operations. Our full-stack partnership, website, campaigns, video, features and events, puts that authenticity in front of every operator who could benefit.",
    services: [
      ["📋", "Campaign Management"],
      ["📈", "Marketing Strategy"],
      ["📰", "Featured Articles"],
      ["✍️", "Copywriting"],
      ["🎥", "Video Production"],
      ["🎬", "Video Editing"],
      ["📸", "Photography"],
      ["📧", "Newsletter Marketing"],
      ["📱", "Social Media Management"],
      ["🌐", "Website Development"],
      ["🛠️", "Website Maintenance"],
      ["⚙️", "Technical Support"],
      ["🚀", "LIFT Campaigns"],
      ["🎪", "Event Marketing"],
    ],
  },
  velocity: {
    partnership:
      "Velocity fixes potholes faster than the weather can create them. Our features and newsletter marketing make sure every council knows the maths behind that claim.",
    services: [
      ["📰", "Featured Articles"],
      ["📧", "Newsletter Marketing"],
    ],
  },
  "blinc-light": {
    partnership:
      "Blinc's illuminated Chapter 8 kit is quietly re-writing roadside conspicuity. Our features, newsletter marketing and video work make sure specifiers see the difference for themselves.",
    services: [
      ["📰", "Featured Articles"],
      ["📧", "Newsletter Marketing"],
      ["🎥", "Video Production"],
    ],
  },
  "uk-sandbags": {
    partnership:
      "UK Sandbags is a quietly essential part of the infrastructure resilience picture. Our features and newsletter marketing keep them front of mind before the next storm, not after.",
    services: [
      ["📰", "Featured Articles"],
      ["📧", "Newsletter Marketing"],
    ],
  },
};
